import { defineStore } from 'pinia'
import { axiosAuth } from "@/main"
import {toJpeg} from "html-to-image"
import {jsPDF} from "jspdf"
import Swal from 'sweetalert2'

export const useVSCStore = defineStore('store', {
    state: () => ({
        noPatrocinador: '',
        user: null,
        creandoCartel: false,
        cartelTimeout: 300,
        meses: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre",
            "Noviembre", "Diciembre"]
    }),
    getters: {
        isLoggedIn: (state) => !!state.user
    },
    actions: {
        async tryAutoLogin() {
            const token = localStorage.getItem('access-token')
            if (token) {
                axiosAuth.defaults.headers.common['Authorization'] = `Bearer ${token}`
                if (!this.isLoggedIn) {
                    await this.getUser()
                }
            }
        },
        async getUser() {
            await axiosAuth.get('api/account-info-vsc.json').then(response => this.user = response.data.user).
            catch(() => this.user = null)
        },
        async logoutActions() {
            localStorage.removeItem('access-token')
            axiosAuth.defaults.headers.common['Authorization'] = ""
            this.user = null
        },
        async crearCartel(nameRoot, downloadOption, original = null, size = null) {
            this.creandoCartel = true

            const date = new Date()
            const currentTime = `${date.getFullYear().toString().slice(-2)}` +
                `${(date.getMonth() + 1).toString().padStart(2,'0')}${date.getDate().toString().padStart(2,'0')}_` +
                `${date.getHours().toString().padStart(2,'0')}${date.getMinutes().toString().padStart(2,'0')}` +
                `${date.getSeconds().toString().padStart(2,'0')}`
            const filename = `${nameRoot}_${currentTime}`
            Swal.fire({
                icon: 'info',
                title: `Generando cartel...`,
                allowOutsideClick: false,
                showConfirmButton: false
            })

            setTimeout(async () => {
                const cartel = document.getElementById('cartel')
                if (cartel) {
                    try {
                        const dataUrl = await toJpeg(cartel, {
                            skipFonts: true,
                            cacheBust: true
                        })

                        if (downloadOption === 'PDF') {
                            const pdf = new jsPDF({
                                orientation: size.orientation,
                                unit: 'px',
                                format: size.format,
                                hotfixes: ["px_scaling"]
                            })

                            let imageWidth = original.width
                            let imageHeight = original.height
                            let offsetX = 0
                            let offsetY = 0
                            if (size.nombre !== 'Original') {
                                const originalRatio = original.width / original.height
                                const pdfRatio = pdf.internal.pageSize.getWidth() / pdf.internal.pageSize.getHeight()
                                if (pdfRatio < originalRatio) {
                                    //El pdf es menos ancho proporcionalmente que la imagen original, sobra altura
                                    imageWidth = pdf.internal.pageSize.getWidth()
                                    imageHeight = imageWidth / originalRatio
                                    offsetY = (pdf.internal.pageSize.getHeight() - imageHeight) / 2
                                } else {
                                    //El pdf es más ancho proporcionalmente que la imagen original, sobra ancho
                                    imageHeight = pdf.internal.pageSize.getHeight()
                                    imageWidth = imageHeight * originalRatio
                                    offsetX = (pdf.internal.pageSize.getWidth() - imageWidth) / 2
                                }
                            }

                            pdf.addImage(dataUrl, 'JPEG', offsetX, offsetY, imageWidth, imageHeight, '',
                                'FAST')
                            pdf.save(`${filename}.pdf`)
                        } else {
                            const link = document.createElement('a')
                            link.download = `${filename}.jpg`
                            link.href = dataUrl
                            link.click()
                        }

                        Swal.close()
                    } catch(error) {
                        console.log(error)
                        this.cartelTimeout *= 2
                        Swal.close()
                        Swal.fire({
                            icon: 'error',
                            title: 'Error al generar cartel',
                            text: "Inténtelo nuevamente"
                        })
                    }
                }

                this.creandoCartel = false
            }, this.cartelTimeout)
        }
    }
})